import { render, staticRenderFns } from "./approval-dialog.vue?vue&type=template&id=3aa97818&scoped=true&"
import script from "./approval-dialog.vue?vue&type=script&lang=js&"
export * from "./approval-dialog.vue?vue&type=script&lang=js&"
import style0 from "./approval-dialog.vue?vue&type=style&index=0&id=3aa97818&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa97818",
  null
  
)

export default component.exports